"use strict";

exports.__esModule = true;
exports.TooltipSkin = void 0;
let TooltipSkin;
exports.TooltipSkin = TooltipSkin;
(function (TooltipSkin) {
  TooltipSkin["Standard"] = "standard";
  TooltipSkin["Error"] = "error";
  TooltipSkin["Wired"] = "wired";
})(TooltipSkin || (exports.TooltipSkin = TooltipSkin = {}));
//# sourceMappingURL=types.js.map